export default __webpack_public_path__ + "static/media/ChevronDown.95af6139.svg";